import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { ParcellaGiudizialeForm } from '../../../form/parcelle/giudiziali/parcella-giudiziale-form';
import { SezioneParcelleGiudizialiResponse } from '../../../models/dto/sezione-parcelle-giudiziali-response';
import { ParcellaGiudiziale } from '../../../models/parcella-giudiziale';
import { SezioneParcelleGiudiziali } from '../../../models/sezioni/sezione-parcelle-giudiziali';

@Component({
    selector: 'div [parcella-giudiziale-form-add]',
  templateUrl: '../../../form/parcelle/giudiziali/parcella-giudiziale-form.html'
})

export class ParcelleGiudizialiAddComponent extends ParcellaGiudizialeForm {
  private idSezione: string;
  private urlInsert: string;
  private urlReadSezioneLegali: string;
  private urlReadSezioneEconomica: string;
  private urlGetScaglioni: string;
  private tipoFascicolo: any;
  private tipoPratica: any;
  private idFascicolo: string;

  @Output() onReturn: EventEmitter<SezioneParcelleGiudiziali> = new EventEmitter<SezioneParcelleGiudiziali>();

  constructor(@Inject(OperationsService) operationService, @Inject(FormBuilder) campiForm, @Inject(HelpersService) helpers: HelpersService) {
        super(operationService, campiForm, helpers);
  }

  ngOnInit() {
    this.setTitle('Aggiungi Parcella');
    this.isInserimento(true);
  }

  getParcellaGiudiziale() {
    return new ParcellaGiudiziale();
  }

  getUrlReadSezioneLegali() {
    return this.urlReadSezioneLegali;
  }

  getUrlReadSezioneEconomica() {
    return this.urlReadSezioneEconomica;
  }

  getTipoFascicolo(): any {
    return this.tipoFascicolo;
  }

  getTipoPratica(): any {
    return this.tipoPratica;
  }

  getIdFascicolo() {
    return this.idFascicolo;
  }

  getUrlGetScaglioni() {
    return this.urlGetScaglioni;
  }

  getRequest(request: ParcellaGiudiziale) {
    this.operationService.addParcellaGiudiziale(this.urlInsert, request, this.idSezione , this.idFascicolo).subscribe((response: any) => this.datiParcellaGiudiziale(response));
  }

  datiParcellaGiudiziale(response: SezioneParcelleGiudizialiResponse) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
    }
  }

  inizializza(idSezione: string,
              idFascicolo: string,
              idSezioneLegali: string,
              idSezioneEconomica: string,
              urlInsert: string,
              urlReadSezioneLegali: string,
              urlReadSezioneEconomica: string,
              urlGetScaglioni: string,
              tipoFascicolo: any,
              tipoPratica: number) {
    this.idSezione = idSezione;
    this.idFascicolo = idFascicolo;
    this.urlInsert = urlInsert;
    this.urlReadSezioneLegali = urlReadSezioneLegali;
    this.urlReadSezioneEconomica = urlReadSezioneEconomica;
    this.urlGetScaglioni = urlGetScaglioni;
    this.tipoFascicolo = tipoFascicolo;
    this.tipoPratica = tipoPratica;
    if (idSezioneLegali) {
      this.readSezioneLegali(idSezioneLegali);
    }
    if (idSezioneEconomica) {
      this.readSezioneEconomica(idSezioneEconomica);
    }
    this.createForm();
    this.populateSelect();
  }

}
